import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule }     from '../shared/shared.module';
import { SidebarComponent } from './sidebar.component';
import { SidebarService }   from './sidebar.service';

@NgModule({
  declarations: [
    SidebarComponent
  ],
  entryComponents: [
    SidebarComponent
  ],
  exports: [
    SidebarComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    SidebarService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class SidebarModule {}
